import { render } from "./SidemenuLayout.vue?vue&type=template&id=6330fdf8"
import script from "./SidemenuLayout.vue?vue&type=script&lang=ts"
export * from "./SidemenuLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script